<template>
  <div>
    <div class="flex flex-wrap alarms-intro-cards">
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/4 ml-auto bg-grid-color pl-3 pr-3"
      >
        <vx-card
          class="overflow-hidden mb-base"
          v-if="isHeaderInfoLoading == true && isPageLoading == true"
        >
          <page-loader :size="'w-6 h-6'" :height="150" />
        </vx-card>
        <StatisticsCard
          v-else
          class="mb-base"
          icon="bell-icon"
          :statistic="alarmLength"
          :statisticTitle="$t('homepage.cards.Alarms')"
          color="warning"
        />
      </div>
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/4 mr-auto bg-grid-color-secondary pr-3 pl-3"
      >
        <vx-card
          class="overflow-hidden mb-base"
          v-if="isHeaderInfoLoading == true && isPageLoading == true"
        >
          <page-loader :size="'w-6 h-6'" :height="150" />
        </vx-card>
        <StatisticsCard
          v-else
          class="mb-base"
          icon="rules-menu-icon"
          :statistic="rulesLength"
          :statisticTitle="$t('alarms.DeclaredRules')"
          color="warning"
        />
      </div>
    </div>
      <Filters />
    <vx-card>
      <div slot="no-body">
      <div id="data-alarm-list-view" class="data-list-container">
        <vs-table
          ref="table"
          :max-items="itemsPerPage"
          :data="alarms"
          :noDataText="noDataText"
          :sst="true"
        >
          <template slot="thead">
            <vs-th sort-key="hive" class="text-left first-th">{{
              $t("alarms.thead.RelatedHive")
            }}</vs-th>
            <vs-th sort-key="apiary" class="text-center min-width-150">{{
              $t("alarms.thead.RelatedApiary")
            }}</vs-th>
            <vs-th sort-key="data_type" class="text-center">{{
              $t("alarms.thead.DataType")
            }}</vs-th>
            <vs-th sort-key="measured_value" class="text-center">{{
              $t("alarms.thead.MeasuredValue")
            }}</vs-th>
            <vs-th sort-key="created_at" class="text-center">{{
              $t("alarms.thead.CreatedAt")
            }}</vs-th>
            <vs-th class="text-center">{{ $t("alarms.thead.Actions") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td style="width: 22rem" class="text-left">
                  <p class="alarms-hive font-medium truncate">{{ tr.hive }}</p>
                </vs-td>
                <vs-td class="text-center" style="min-width:150px">
                  <p class="alarms-apiary">{{ tr.apiary }}</p>
                </vs-td>

                <vs-td class="text-center">
                  <p class="alarms-data-type">{{ tr.data_type }}</p>
                </vs-td>

                <vs-td class="text-center">
                  <p class="alarms-measured-value">{{ tr.var_value }}</p>
                </vs-td>

                <vs-td class="text-center">
                  <p class="alarms-measured-value">
                    {{ tr.created_at }}
                  </p>
                </vs-td>
                <vs-td
                  class="whitespace-no-wrap text-center"
                  style="width: 120px"
                >
                  <div class="flex justify-center">
                    <VxTooltip
                      position="bottom"
                      color="dark"
                      :text="$t('alarms.DeleteModalTitle')"
                    >
                      <feather-icon
                        icon="TrashIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current"
                        @click.stop="deleteItem(tr)"
                      />
                    </VxTooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
        <div class="center con-pagination p-6">
          <div class="flex justify-end items-center">
            <vs-pagination
                color="warning"
                v-model="page"
                :total="totalPagination"
              />
          </div>
        </div>
      </div>
      </div>

    </vx-card>

    <vs-prompt
      blur
      @cancel="cancelDeleteAlarmModal"
      @accept="deleteAlarm"
      @close="cancelDeleteAlarmModal"
      :accept-text="$t('alarms.ButtonDelete')"
      :cancel-text="$t('alarms.ButtonClose')"
      :active.sync="deleteAlarmModal"
      color="warning"
      :title="$t('alarms.DeleteModalTitle')"
    >
      <div class="con-exemple-prompt">
        <div class="text-center pt-8 pb-5">
          <feather-icon
            icon="AlertTriangleIcon"
            svgClasses="w-10 h-10 hover:text-primary stroke-current"
          />
          <div class="mt-3">{{ $t("alarms.DeleteAlarmQuestion") }}</div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import StatisticsCard from './components/statistics-card.vue'
import i18n from '../../i18n/i18n.js'
import VxTooltip from '../../layouts/components/vx-tooltip/VxTooltip.vue'
import Filters from './components/filters.vue'
import PageLoader from '../../components/Loader.vue'

export default {
  components:{
    PageLoader,
    StatisticsCard,
    VxTooltip,
    Filters
  },
  data () {
    return {
      deleteAlarmModal: false,
      noDataText: i18n.t('table.LoadingText'),
      itemsPerPage: 10,
      alarmID: '',
      rulesLength: 0,
      alarmLength: 0,
      alarms: [],
      page: 1,
      lastPage: 1,
      totalPagination: 1,
      lastpageDataCount: 0,
      nextApi: null,
      previousApi: null,
      isPageLoading: true,
      isHeaderInfoLoading: true,
      lastUrlData: null,
      selectItem:null
    }
  },
  watch: {
    page () {
      if (this.page > this.lastPage) {
        if (this.nextApi !== null) {
          this.alarms = []
          this.noDataText = i18n.t('alarms.Loading')
          this.getPreviousNextAlarmList(this.nextApi, 'next')
          this.lastPage = this.page
        }
      }
      if (this.page < this.lastPage) {
        if (this.previousApi !== null) {
          this.alarms = []
          this.noDataText = i18n.t('alarms.Loading')
          this.getPreviousNextAlarmList(this.previousApi, 'previous')
          this.lastPage = this.page
        }
      }
    },
    alarmFilters:{
      handler (n, o) {
        if (o) {
          if (n.apiary === null && n.hive === null && n.search === null) {
            this.getAlarmList('')
          } else {
            let params = ''

            if (n.apiary !== null) {
              params += params === ''
                ? `?hive__apiary=${  n.apiary}`
                : `&hive__apiary=${  n.apiary}`
            }

            if (n.hive !== null) {
              params += params === ''
                ? `?hive=${  n.hive}`
                : `&hive=${  n.hive}`
            }

            if (n.search !== null) {
              params += params === ''
                ? `?search=${  n.search}`
                : `&search=${  n.search}`
            }
           
            this.getAlarmList(params)
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.getAlarmAndRulesCount()
  },
  computed: {
    alarmData () {
      return this.$store.getters.returnAlarmData
    },
    alarmFilters () {
      return this.$store.getters.alarmFilters
    }
  },
  methods: {
    getAlarmAndRulesCount () {
      this.isHeaderInfoLoading = true
      this.$store
        .dispatch('getAlarmAndRulesCount')
        .then((response) => {
          if (response.data) {
            this.alarmLength = response.data.alarm_count
            this.rulesLength = response.data.rule_count
            this.isHeaderInfoLoading = false
            this.getAlarmList('')
          }
        })
        .catch((error) => {
          this.isHeaderInfoLoading = false
          this.noDataText = i18n.t('alarms.NoDataError')
          this.errorMsg(error)
        })
    },
    getAlarmList (params) {
      this.page = 1
      this.lastPage = 1
      this.$store
        .dispatch('getAlarmList', params)
        .then((response) => {
          this.alarms = []
          this.nextApi = response.data.next
          this.previousApi = response.data.previous

          if (!response.data.results.length) {
            this.noDataText = i18n.t('alarms.NoAlarm')
            this.totalPagination = 1
          } else {
            this.alarms = this.alarmData
            this.noDataText = i18n.t('table.NoMatch')
          }
          if (response.data.next) {
            this.totalPagination = 2
          }
          this.isPageLoading = false
        })
        .catch((error) => {
          this.totalPagination = 1
          this.isPageLoading = false
          this.noDataText = i18n.t('alarms.NoDataError')
          this.errorMsg(error)
        })
    },
    getPreviousNextAlarmList (url, type) {
      this.$store
        .dispatch('getPreviousNextAlarmList', url)
        .then((response) => {
          this.nextApi = response.data.next
          this.previousApi = response.data.previous

          if (!response.data.results.length) {
            this.noDataText = i18n.t('alarms.NoAlarm')
          } else {
            this.alarms = this.alarmData
          }

          if (response.data.next && type === 'next') {
            this.totalPagination = this.totalPagination + 1
          }
        })
        .catch((error) => {
          this.noDataText = i18n.t('alarms.NoDataError')
          this.errorMsg(error)
        })
    },

    deleteItem (item) {
      this.selectItem = item
      this.deleteAlarmModal = true
    },

    cancelDeleteAlarmModal () {
      this.selectItem = null
      this.deleteAlarmModal = false
    },

    deleteAlarm () {
      this.$store
        .dispatch('deleteAlarm', { id: this.selectItem.id})
        .then(() => {
          this.isHeaderInfoLoading = true
          this.alarmLength = this.alarmLength - 1
          this.isHeaderInfoLoading = false

          if (this.alarmFilters.apiary === null && this.alarmFilters.hive === null && this.alarmFilters.search === null) {
            this.getAlarmList('')
          } else {
            let params = ''

            if (this.alarmFilters.apiary !== null) {
              params += params === ''
                ? `?hive__apiary=${  this.alarmFilters.apiary}`
                : `&hive__apiary=${  this.alarmFilters.apiary}`
            }

            if (this.alarmFilters.hive !== null) {
              params += params === ''
                ? `?hive=${  this.alarmFilters.hive}`
                : `&hive=${  this.alarmFilters.hive}`
            }

            if (this.alarmFilters.search !== null) {
              params += params === ''
                ? `?search=${  this.alarmFilters.search}`
                : `&search=${  this.alarmFilters.search}`
            }
           
            this.getAlarmList(params)
          }

          this.$vs.notify({
            title: i18n.t('register.ModalSuccess.Title'),
            text: i18n.t('alarms.DeleteSuccess'),
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            position: 'top-right'
          })
          this.selectItem = null
        })
        .catch((error) => {
          this.errorMsg(error)
        })
    },
    errorMsg (error) {
      this.$store.dispatch('errorMsg', error).then((res) => {
        this.$vs.notify({
          title: i18n.t('notifyAlert.error.title'),
          text: res,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      })
    }
  }
}
</script>

<style lang="scss">
#data-alarm-list-view {
  .first-th .vs-table-text {
    justify-content: left !important;
  }
   .min-width-150 .vs-table-text {
    min-width: 150px;
  }
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 18rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.6rem 2rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
          display: none;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        padding: 0 20px !important;
        text-align: center;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
          text-align: center;
        }
      }
      th.td-check {
        padding: 0 20px !important;
        display: none;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }

    .vs-pagination--buttons i {
      font-size: 1.8rem;
    }
  }

  th .vs-table-text {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: center !important;
  }

  .vs-pagination--li.is-current {
    background: #ff9f43 !important;
  }
  .vs-pagination-primary .effect,
  .vs-pagination-primary .vs-pagination--buttons:hover {
    background: #ff9f43 !important;
  }
  .not-data-table {
    background: #fff;
    padding: 20px;
    font-weight: 600;
    border-radius: 0.5rem;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
  }
  .vs-pagination--ul {
    display: none;
  }
}

@media (max-width: 789px) {
  .alarms-intro-cards .w-1\/3 {
    width: 50% !important;
  }
}

@media (max-width: 400px) {
  .alarms-intro-cards .w-1\/3 {
    width: 100% !important;
  }
}
</style>
<style lang="scss">

.height-150 {
  height: 150px;
}
</style>